module.exports = __webpack_public_path__ + "static/media/ios-pause.58d97c29.svg";